import { ReactNode, FC, createContext, useState, useMemo } from 'react';
import * as types from '@models/types';


type ProfileContextType = {
    provinceList?: types.SelectedProfileChildrenTypes[];
    setProvinceList?: React.Dispatch<React.SetStateAction<types.SelectedProfileChildrenTypes[]>>;
    sectorsData?: types.SelectedProfileChildrenTypes[];
    setSectorsData?: React.Dispatch<React.SetStateAction<types.SelectedProfileChildrenTypes[]>>;
    occupationsData?: types.SelectedProfileChildrenTypes[];
    setOccupationsData?: React.Dispatch<React.SetStateAction<types.SelectedProfileChildrenTypes[]>>;
    specializationsData?: types.SelectedProfileChildrenTypes[];
    setSpecializationsData?: React.Dispatch<React.SetStateAction<types.SelectedProfileChildrenTypes[]>>;
    timelinesData?: types.SelectedProfileChildrenTypes[];
    setTimelinesData?: React.Dispatch<React.SetStateAction<types.SelectedProfileChildrenTypes[]>>;
    jobSourcesData?: types.JobSourcesTypes[];
    setJobSourcesData?: React.Dispatch<React.SetStateAction<types.JobSourcesTypes[]>>;
    universityProgramsData?: types.UniversityProgramsTypes[];
    setUniversityProgramsData?: React.Dispatch<React.SetStateAction<types.UniversityProgramsTypes[]>>;
};

const ProfileContext = createContext<ProfileContextType>({});


type ProfileProps = {
  children: ReactNode;
};

const Profile: FC<ProfileProps> = ({ children }) => {
    const [sectorsData, setSectorsData] = useState<types.SelectedProfileChildrenTypes[]>([]);
    const [occupationsData, setOccupationsData] = useState<types.SelectedProfileChildrenTypes[]>([]);
    const [specializationsData, setSpecializationsData] = useState<types.SelectedProfileChildrenTypes[]>([]);
    const [provinceList, setProvinceList] = useState<types.SelectedProfileChildrenTypes[]>([]);
    const [timelinesData, setTimelinesData] = useState<types.SelectedProfileChildrenTypes[]>([]);
    const [jobSourcesData, setJobSourcesData] = useState<types.JobSourcesTypes[]>([]);
    const [universityProgramsData, setUniversityProgramsData] = useState<types.UniversityProgramsTypes[]>([]);

    const ProfileProviderValue = useMemo(
        () => ({
            sectorsData,
            setSectorsData,
            occupationsData,
            setOccupationsData,
            specializationsData,
            setSpecializationsData,
            timelinesData,
            setTimelinesData,
            provinceList,
            setProvinceList,
            jobSourcesData,
            setJobSourcesData,
            universityProgramsData,
            setUniversityProgramsData
        }),
        [sectorsData, setSectorsData, occupationsData, setOccupationsData, specializationsData, setSpecializationsData, timelinesData, setTimelinesData, provinceList, setProvinceList, jobSourcesData, setJobSourcesData, universityProgramsData, setUniversityProgramsData],
  );

  return (
      <ProfileContext.Provider value={ProfileProviderValue}>
      {children}
    </ProfileContext.Provider>
  );
};

export { Profile, ProfileContext };
